'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import SuspenseWithLoader from '../SuspenseWithLoader';
import ProductListingPagePlaceholder from '../ProductListingPage/ProductListingPagePlaceholder';
import CategoryPageAlgolia from '../category-page-algolia';
import { PAGE_TYPE } from '../category-page-algolia/categoryPageTypes';
const stripLeadingAndTrailingSlash = path => {
  const pathWithoutLeadingSlash = path.startsWith('/') ? path.slice(1) : path;
  const pathWithoutTrailingSlash = pathWithoutLeadingSlash.endsWith('/') ? pathWithoutLeadingSlash.slice(0, -1) : pathWithoutLeadingSlash;
  return pathWithoutTrailingSlash;
};
const CategoryPage = t0 => {
  const $ = _c(12);
  const {
    slug: slugProp,
    serverCategoryData,
    pageType,
    algoliaUserToken
  } = t0;
  const location = useLocation();
  const pathname = location?.pathname || "";
  let t1;
  if ($[0] !== pathname || $[1] !== slugProp) {
    t1 = slugProp || stripLeadingAndTrailingSlash(pathname);
    $[0] = pathname;
    $[1] = slugProp;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const slug = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ProductListingPagePlaceholder />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== algoliaUserToken || $[5] !== pageType || $[6] !== serverCategoryData || $[7] !== slug) {
    t3 = <CategoryPageAlgolia key={slug} slug={slug} serverCategoryData={serverCategoryData} pageType={pageType} algoliaUserToken={algoliaUserToken} />;
    $[4] = algoliaUserToken;
    $[5] = pageType;
    $[6] = serverCategoryData;
    $[7] = slug;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== slug || $[10] !== t3) {
    t4 = <SuspenseWithLoader fallback={t2} key={slug}>{t3}</SuspenseWithLoader>;
    $[9] = slug;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
CategoryPage.propTypes = {
  slug: PropTypes.string,
  serverCategoryData: PropTypes.object,
  pageType: PropTypes.oneOf(Object.values(PAGE_TYPE)),
  algoliaUserToken: PropTypes.string
};
export default CategoryPage;